(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('InstitucionesClases', InstitucionesClases);

    InstitucionesClases.$inject = ['$resource'];

    function InstitucionesClases ($resource) {
        var resourceUrl =  'apo/institucionesclases';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
